function RatingStars({ value = 0, onChange }) {
  return (
    <div style={{ display: "flex", gap: "6px" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          onClick={() => onChange && onChange(star)}
          style={{
            cursor: onChange ? "pointer" : "default",
            fontSize: "22px",
            color: star <= value ? "#facc15" : "#555",
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
}

export default RatingStars;
